import React from 'react';

export default function RadioMusicVisual({
  isPlaying = false,
  barCount = 5,
  className = '',
  variant = 'dock',
}) {
  const safeBarCount = Math.max(1, Math.min(8, Number(barCount) || 5));
  const classNames = [
    'radio-music-visual',
    `radio-music-visual--${variant}`,
    className,
    isPlaying ? 'is-playing' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} aria-hidden="true">
      {Array.from({ length: safeBarCount }, (_, index) => (
        <span key={index} />
      ))}
    </div>
  );
}
